'use strict';

(function () {
    const main = document.querySelector('main');

    const felanmalan = document.getElementById('felanmalan');
    if (felanmalan != null) {
        hanteraFelanmalan();
    }

    const felanmalanSida = document.getElementById('felanmalan-sida');
    if (felanmalanSida != null) {
        hanteraFelanmalanSida();
    }

    window.doljFilerFelmeddelande = () => {
        document.querySelector('.invalid-feedback.filer').innerHTML = '';
        document.querySelector('.invalid-feedback.filer').style.display = 'none';
    }

    function visaFilFelmeddelande() {
        document.querySelector('.invalid-feedback.filer').style.display = 'block';
        document.querySelector('.invalid-feedback.filer').innerHTML = AlectaFastigheter.CustomMultifile.getValidationText();
    }

    window.visaFelmeddelandeValdAdress = (target) => {
        const element = target ? target : document.querySelector('.invalid-feedback.vald-adress');

        element.innerHTML = 'Välj en adress';
        element.style.display = 'block';
    }

    window.doljFelmeddelandeValdAdress = (target) => {
        const element = target ? target : document.querySelector('.invalid-feedback.vald-adress');

        element.innerHTML = '';
        element.style.display = 'none';
    }

    function hanteraAnslagstavlan() {
        anslagstavlan.addEventListener('submit', function (e) {
            const MAX_FILE_SIZE = AlectaFastigheter.CustomMultifile.getMaxFileSize();
            const totalFileSize = (AlectaFastigheter.CustomMultifile.sumFileSizes(AlectaFastigheter.CustomMultifile.uploadedFiles) / 1024);
            const adressSelect = e.target.querySelector('#Formular_ValdAdress');
            const adressSelectValue = adressSelect !== null ? adressSelect.value == '' : false;

            e.preventDefault();
            const id = e.target.id;
            var form = $('#' + id)
                .removeData('validator')
                .removeData('unobtrusiveValidation');

            $.validator.unobtrusive.parse(form);

            if (!(totalFileSize <= MAX_FILE_SIZE)) {
                visaFilFelmeddelande()
            } else {
                doljFilerFelmeddelande()
            }

            if (adressSelect.value == '') {
                if (adressSelect.value == '') {
                    visaFelmeddelandeValdAdress()
                } else {
                    doljFelmeddelandeValdAdress()
                }
            }

            if (!(totalFileSize <= MAX_FILE_SIZE) || adressSelectValue) {
                $(anslagstavlan).find('form').valid();

                return false
            }

            registreraFelanmalan(e.target.id);
        });
    }

    function hanteraFelanmalan() {
        hanteraAdress();
        hanteraPrivatBostadModal();

        const elList = document.querySelectorAll('.form-multifile--list');
        if (elList) {
            [...elList].forEach((item) => {
                item.addEventListener('click', e => {
                    
                    if (e.target.matches('button')) {
                        const MAX_FILE_SIZE = AlectaFastigheter.CustomMultifile.getMaxFileSize();
                        const totalFileSize = (AlectaFastigheter.CustomMultifile.sumFileSizes(AlectaFastigheter.CustomMultifile.uploadedFiles) / 1024);
                        if (totalFileSize <= MAX_FILE_SIZE) {
                            window.doljFilerFelmeddelande();
                        }
                    }
                })
            })
        }

        felanmalan.addEventListener('submit', function (e) {
            const MAX_FILE_SIZE = AlectaFastigheter.CustomMultifile.getMaxFileSize();
            const totalFileSize = (AlectaFastigheter.CustomMultifile.sumFileSizes(AlectaFastigheter.CustomMultifile.uploadedFiles) / 1024);
            const adressSelect = document.getElementById('Formular_ValdAdress');
            const adressValidationElement = e.target.querySelector('.vald-adress');
            
            e.preventDefault();
            if (hanteraEnPrivatBostad()) {

                if (!(totalFileSize <= MAX_FILE_SIZE)) {
                    visaFilFelmeddelande()
                    return false
                } else {
                    doljFilerFelmeddelande()
                }

                if (adressSelect.value === '') {
                    if (adressSelect.value === '') {
                        visaFelmeddelandeValdAdress(adressValidationElement)
                        return false
                    } else {
                        doljFelmeddelandeValdAdress(adressValidationElement)
                    }
                }

                registreraFelanmalan(e.target.id);
            }
        });

        function stangPrivatBostadModal() {
            $('#privat-bostad-modal-hyres').modal('hide');
        }
        
        function hanteraPrivatBostadModal() {
            const modalGaVidare = document.getElementById('privat-felanmalan-fastighet-ga-vidare');
            const modalStang = document.getElementById('privat-felanmalan-fastighet-stang');
            modalGaVidare.addEventListener('click', stangPrivatBostadModal);
            modalStang.addEventListener('click', stangPrivatBostadModal);
        }

        function hanteraEnPrivatBostad() {
            const arPrivatBostad = document.getElementById('ar-privat-bostad');
            const arModalVisad = document.getElementById('privat-modal-visad');
            var adressSelect = document.getElementById('Formular_ValdAdress');
            if (adressSelect.tagName.toLowerCase() == 'input' && arPrivatBostad.value == 'True' && arModalVisad.value == 'False') {
                $('#privat-bostad-modal-hyres').modal('show');
                arModalVisad.value = 'True';

                const link = document.getElementById('Formular_ExternFelanmalanUrl').value;
                const faqelement = document.getElementById('fastighet-faq-link');
                let safeFaqLink = encodeURI(link);
                faqelement.href = safeFaqLink;
                return false;
            }
            else if (adressSelect.tagName.toLowerCase() == 'input' && arPrivatBostad.value == 'True' && arModalVisad.value == 'True') {
                return true;
            }
            return true;
        }

        function hanteraAdressDropDown( event ) {
            var adressSelect = event.target;
            var option = adressSelect.options[adressSelect.selectedIndex];
            if ((option.value != '')) {
                doljFelmeddelandeValdAdress();
                if (option.dataset.arBostadsadress == 'True') {
                    $('#privat-bostad-modal-hyres').modal('show');
                    const link = document.getElementById('Formular_ExternFelanmalanUrl').value;
                    const faqelement = document.getElementById('fastighet-faq-link');
                    faqelement.href = link;
                }
            }
        }

        function hanteraAdress() {
            var adressSelect = document.getElementById('Formular_ValdAdress');
            if (adressSelect.tagName.toLowerCase() != 'input') {
                adressSelect.addEventListener('change', hanteraAdressDropDown);
            }
        }
    }

    function hanteraFelanmalanSida() {
        felanmalanSida.addEventListener('submit', function (e) {
            e.preventDefault();
            registreraFelanmalan(e.target.id);
        });
    }

    function rensaFormular(id) {
        const felanmalanFormular = document.getElementById(id);
        felanmalanFormular.Formular_Namn.value = '';
        felanmalanFormular.Formular_Foretag.value = '';
        felanmalanFormular.Formular_Mejladress.value = '';
        felanmalanFormular.Formular_Telefon.value = '';
        felanmalanFormular.Formular_Beskrivning.value = '';
        felanmalanFormular.Formular_CurrentPageLink.value = '';
        felanmalanFormular.Formular_ValdAdress.value = '';
        felanmalanFormular.Formular_Fastighetsbeteckning.value = '';
        felanmalanFormular.Formular_FastighetsEpostadress.value = '';
        $('.form-multifile input[type="file"]').val('');
        AlectaFastigheter.CustomMultifile.clearFiles()
    }

    function registreraFelanmalan(id) {
        const felanmalanResultat = document.getElementById(id + '-felanmalanresultat');
        const kundservice = document.getElementById('kundservice');

        const eventString = (formId) => {
            switch (formId) {
            case 'livlinanformular':
                return 'Från digitala hyrestavlan'
            case 'felanmalansida':
                return 'Från sidan felanmälan'
            default: 
                return 'Från fastighetssida'
            }
        }

        if ($('#' + id).valid()) {
            const felanmalanFormular = document.getElementById(id);
            const formular = new FormData($('#' + id).get(0));
            const formFiles = AlectaFastigheter.CustomMultifile.uploadedFiles

            if (formFiles.length >= 1) {
                formFiles.forEach((file) => {
                    formular.append('bilagor', file);
                });
            } 
            
            const felanmalanModel =
            {
                Namn: felanmalanFormular.Formular_Namn.value,
                Foretag: felanmalanFormular.Formular_Foretag.value,
                Mejladress: felanmalanFormular.Formular_Mejladress.value,
                Telefon: felanmalanFormular.Formular_Telefon.value,
                Beskrivning: felanmalanFormular.Formular_Beskrivning.value,
                CurrentPageLink: felanmalanFormular.Formular_CurrentPageLink.value,
                ValdAdress: felanmalanFormular.Formular_ValdAdress.value,
                Fastighetsbeteckning: felanmalanFormular.Formular_Fastighetsbeteckning,
                FastighetsEpostadress: felanmalanFormular.Formular_FastighetsEpostadress,
                __RequestVerificationToken: document.querySelector('[name=__RequestVerificationToken]').value
            };
            
            formular.append('Namn', felanmalanModel.Namn);
            formular.append('Foretag', felanmalanModel.Foretag);
            formular.append('Mejladress', felanmalanModel.Mejladress);
            formular.append('Telefon', felanmalanModel.Telefon);
            formular.append('Beskrivning', felanmalanModel.Beskrivning);
            formular.append('CurrentPageLink', felanmalanModel.CurrentPageLink);
            formular.append('ValdAdress', felanmalanModel.ValdAdress);
            formular.append('Fastighetsbeteckning', felanmalanModel.Fastighetsbeteckning);
            formular.append('FastighetsEpostadress', felanmalanModel.FastighetsEpostadress);
            
            let url = '';           
            if (felanmalanFormular.Formular_FelAnmalanSidaUrl) {
                url = felanmalanFormular.Formular_FelAnmalanSidaUrl.value;
            }

            $.ajax({
                cache: false,
                contentType: false,
                processData: false,
                url: felanmalanFormular.action,
                type: 'POST',
                data: formular,
                success: function (response) {
                    felanmalanResultat.innerHTML = response;
                    felanmalanResultat.setAttribute('style', 'display:block');
                    felanmalanFormular.setAttribute('style', 'display:none');
                    if (id === 'livlinanformular') {
                        anslagstavlan.scrollTo({ top: 0, behavior: 'smooth' });
                    } else if (id === 'felanmalansida') {
                        felanmalansida.visaBekraftelse();
                    } else {
                        if (kundservice !== null) {
                            main.scrollTo({ top: kundservice.offsetTop - 100, behavior: 'smooth' });
                        }
                    }

                    window._mtm.push({
                        'event': 'Felanmälan',
                        'category': eventString(id)
                    })

                    rensaFormular(id);
                },
                statusCode: {
                    500: function () {
                        felanmalanResultat.setAttribute('style', 'display:block');
                        felanmalanResultat.innerHTML = 'Oj, något gick fel i felanmälan, var god försök igen' + '<br /><a id="borja" href="' + url + '">Gör en ny felanmälan</a>';
                    }
                },
                error: function () {
                    felanmalanResultat.setAttribute('style', 'display:block');
                    felanmalanResultat.innerHTML = 'Något gick fel i felanmälan, var god försök igen';
                    felanmalanFormular.setAttribute('style', 'display:none');
                    if (id === 'livlinanformular') {
                        anslagstavlan.scrollTo({ top: 0, behavior: 'smooth' });
                    } else if (id === 'felanmalansida') {
                        felanmalansida.visaBekraftelse();
                    }
                    else {
                        if (kundservice !== null) {
                            main.scrollTo({ top: kundservice.offsetTop - 100, behavior: 'smooth' });
                        }
                    }
                }
            });
        }
    }
})();


